// extracted by mini-css-extract-plugin
module.exports = {"glenGuide":"Guide_glenGuide__2y24t","girl1":"Guide_girl1___hIzn","girl2":"Guide_girl2__MmuNY"};